import styled from "@emotion/styled";

export const Answer = styled("div")({
  whiteSpace: "pre-wrap",
});
